module.exports = __webpack_public_path__ + "static/media/search.a2196a4c.svg";